import {
  ConsultaSeguimentoAplicacaoItemModel,
  ConsultaSeguimentoOutroFieldModel,
} from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export enum ConsultaSeguimentoPergunta09TrazPraVoceEnum {
  FIGURA_OU_BRINQUEDO = 'FIGURA_OU_BRINQUEDO',
  DESENHO_QUE_ELE_FEZ = 'DESENHO_QUE_ELE_FEZ',
  FLOR_QUE_ELE_PEGOU = 'FLOR_QUE_ELE_PEGOU',
  BICHINHO_QUE_ELE_ENCONTROU = 'BICHINHO_QUE_ELE_ENCONTROU',
  PECAS_QUE_ELE_JUNTOU = 'PECAS_QUE_ELE_JUNTOU',
}

export interface ConsultaSeguimentoPergunta09Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_09_HEADER?: SimNaoEnum
  PERGUNTA_09_TRAZ_PRA_VOCE?: Record<ConsultaSeguimentoPergunta09TrazPraVoceEnum, SimNaoEnum | undefined>
  PERGUNTA_09_SO_PARA_MOSTRAR?: SimNaoEnum
  OUTRO?: ConsultaSeguimentoOutroFieldModel
}
